export default "__VITE_ASSET__BeI$JvRC__"